import { TApplicationState } from 'shared/types/redux';

export function priceForMeterSelector(state: TApplicationState) {
  return state.newbuilding.priceForMeterFromDeveloperDisplay;
}
